import './CalendarOutlineIcon.css';
export var calendarIndicatorBackgroundCSS = '_1uazq662-3-15-1';
export var calendarIndicatorCSS = '_1uazq661-3-15-1';
export var calendarOutlineCSS = '_1uazq660-3-15-1';
export var calendarRangeCornersCSS = '_1uazq663-3-15-1';
export var calendarRangeCornorVisibleCSS = '_1uazq664-3-15-1';